import { render, staticRenderFns } from "./manage-plan.component.vue?vue&type=template&id=aa8b5fb4&"
import script from "./manage-plan.component.vue?vue&type=script&lang=ts&"
export * from "./manage-plan.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports